import * as React from "react";
import { useInstantSearch, useCurrentRefinements, Configure } from "react-instantsearch";
import { InfinitePagination } from "@grandvisionhq/common";
import { useLocation } from "@grandvisionhq/frk-routing";
import { useIsClient } from "@grandvisionhq/lib-utils-react";
import { useIntl } from "@grandvisionhq/state";
import { useItemsToClear } from "../../Algolia/hooks/Algolia/hooks/use-items-to-clear.js";
import { useAlgoliaData } from "../../Algolia/hooks/Algolia/hooks/use-algolia-data.js";
import { useAlgoliaConfig } from "../../Algolia/Algolia/AlgoliaConfig.js";
const ConnectedInfinitePagination = ({ labelKey }) => {
  const isMounted = useIsClient();
  const { setIndexUiState } = useAlgoliaData();
  const {
    results: { nbHits: total },
    status
  } = useInstantSearch();
  const isLoading = status === "loading";
  const { getLabel } = useIntl();
  const { pageSize } = useAlgoliaConfig();
  const { items } = useCurrentRefinements();
  const itemsFiltered = useItemsToClear(items);
  const itemsFilteredRef = React.useRef(itemsFiltered);
  const { query } = useLocation();
  const page = Number(query.get("page") ?? 1);
  const [length, setLength] = React.useState(page * pageSize);
  React.useEffect(() => {
    if (itemsFiltered.length !== itemsFilteredRef.current.length && page > 1) {
      setIndexUiState((prev) => ({
        ...prev,
        configure: { ...prev.configure, length: pageSize, offset: 0, page: 1 }
      }));
      setLength(pageSize);
    }
    itemsFilteredRef.current = itemsFiltered;
  }, [itemsFiltered, page]);
  const handleClick = () => {
    const newLength = Math.min(length + pageSize, 1e3);
    setLength(newLength);
    setIndexUiState((prev) => ({ ...prev, configure: { ...prev.configure, length: newLength } }));
  };
  const currentPage = Math.round(length / pageSize);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isMounted ? /* @__PURE__ */ React.createElement(Configure, { offset: 0, length }) : null, /* @__PURE__ */ React.createElement(
    InfinitePagination,
    {
      onClick: handleClick,
      buttonLabel: getLabel("search.loadMore"),
      labelKey: labelKey ?? "search.pagingStatus",
      loaded: length,
      isLoading,
      total,
      currentPage
    }
  ));
};
export {
  ConnectedInfinitePagination
};
//# sourceMappingURL=InfinitePagination.js.map
